import type { ISerialize } from '@/objects/ISerialize';
import type { DbDataChangedNotificationDtoType } from './../enums/DbDataChangedNotificationDtoType';

export class SignalrDbDataChangedSubscribeParameters implements ISerialize {
    public DtoType: DbDataChangedNotificationDtoType;

    public EventID: number | null;

    public OrganizerID: number | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { DtoType?: DbDataChangedNotificationDtoType; EventID?: number | null; OrganizerID?: number | null }) {
        this.DtoType = values.DtoType ?? 'BiathlonPicture';

        this.EventID = values.EventID ?? null;

        this.OrganizerID = values.OrganizerID ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"DtoType": ${this.DtoType == 'BiathlonPicture' ? 0 : this.DtoType == 'Category' ? 1 : this.DtoType == 'CommunicationToApprove' ? 2 : this.DtoType == 'ContestantAndRaceContestantTime' ? 3 : this.DtoType == 'DeviceEvent' ? 4 : this.DtoType == 'DeviceStation' ? 5 : this.DtoType == 'DeviceStatusStation' ? 6 : this.DtoType == 'EventImplementation' ? 7 : this.DtoType == 'Eventinfo' ? 8 : this.DtoType == 'EventinfoBase' ? 9 : this.DtoType == 'EventinfoSearchlistItem' ? 10 : this.DtoType == 'EventInfoSelectLine' ? 11 : this.DtoType == 'EventLocation' ? 12 : this.DtoType == 'EventNameDateId' ? 13 : this.DtoType == 'EventSetup' ? 14 : this.DtoType == 'EventTeam' ? 15 : this.DtoType == 'FocusEvent' ? 16 : this.DtoType == 'Group' ? 17 : this.DtoType == 'GroupWithCount' ? 18 : this.DtoType == 'HeatPlan' ? 19 : this.DtoType == 'ManagerReport' ? 20 : this.DtoType == 'MatrixShootingCellWarningsAcknowledgement' ? 21 : this.DtoType == 'Participant' ? 22 : this.DtoType == 'Race' ? 23 : this.DtoType == 'RaceContestantComplete' ? 24 : this.DtoType == 'RaceContestantDetails' ? 25 : this.DtoType == 'RankedTime' ? 26 : this.DtoType == 'Report' ? 27 : this.DtoType == 'ReportParameter' ? 28 : this.DtoType == 'ResultSetup' ? 29 : this.DtoType == 'SignupSettings' ? 30 : this.DtoType == 'StartingNumber' ? 31 : this.DtoType == 'StartnumberDbStateModel' ? 32 : this.DtoType == 'Station' ? 33 : this.DtoType == 'StationDetails' ? 34 : this.DtoType == 'StationRole' ? 35 : this.DtoType == 'UserRole' ? 36 : 0}` +
            ',' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"OrganizerID": ${JSON.stringify(this.OrganizerID)}` +
            '}'
        );
    }

    /**
     * Creates an instance of SignalrDbDataChangedSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        DtoType?: DbDataChangedNotificationDtoType;
        EventID?: number | null;
        OrganizerID?: number | null;
    }): SignalrDbDataChangedSubscribeParameters {
        return new SignalrDbDataChangedSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrDbDataChangedSubscribeParameters {
        return new SignalrDbDataChangedSubscribeParameters({
            DtoType:
                json.DtoType == 0
                    ? 'BiathlonPicture'
                    : json.DtoType == 1
                      ? 'Category'
                      : json.DtoType == 2
                        ? 'CommunicationToApprove'
                        : json.DtoType == 3
                          ? 'ContestantAndRaceContestantTime'
                          : json.DtoType == 4
                            ? 'DeviceEvent'
                            : json.DtoType == 5
                              ? 'DeviceStation'
                              : json.DtoType == 6
                                ? 'DeviceStatusStation'
                                : json.DtoType == 7
                                  ? 'EventImplementation'
                                  : json.DtoType == 8
                                    ? 'Eventinfo'
                                    : json.DtoType == 9
                                      ? 'EventinfoBase'
                                      : json.DtoType == 10
                                        ? 'EventinfoSearchlistItem'
                                        : json.DtoType == 11
                                          ? 'EventInfoSelectLine'
                                          : json.DtoType == 12
                                            ? 'EventLocation'
                                            : json.DtoType == 13
                                              ? 'EventNameDateId'
                                              : json.DtoType == 14
                                                ? 'EventSetup'
                                                : json.DtoType == 15
                                                  ? 'EventTeam'
                                                  : json.DtoType == 16
                                                    ? 'FocusEvent'
                                                    : json.DtoType == 17
                                                      ? 'Group'
                                                      : json.DtoType == 18
                                                        ? 'GroupWithCount'
                                                        : json.DtoType == 19
                                                          ? 'HeatPlan'
                                                          : json.DtoType == 20
                                                            ? 'ManagerReport'
                                                            : json.DtoType == 21
                                                              ? 'MatrixShootingCellWarningsAcknowledgement'
                                                              : json.DtoType == 22
                                                                ? 'Participant'
                                                                : json.DtoType == 23
                                                                  ? 'Race'
                                                                  : json.DtoType == 24
                                                                    ? 'RaceContestantComplete'
                                                                    : json.DtoType == 25
                                                                      ? 'RaceContestantDetails'
                                                                      : json.DtoType == 26
                                                                        ? 'RankedTime'
                                                                        : json.DtoType == 27
                                                                          ? 'Report'
                                                                          : json.DtoType == 28
                                                                            ? 'ReportParameter'
                                                                            : json.DtoType == 29
                                                                              ? 'ResultSetup'
                                                                              : json.DtoType == 30
                                                                                ? 'SignupSettings'
                                                                                : json.DtoType == 31
                                                                                  ? 'StartingNumber'
                                                                                  : json.DtoType == 32
                                                                                    ? 'StartnumberDbStateModel'
                                                                                    : json.DtoType == 33
                                                                                      ? 'Station'
                                                                                      : json.DtoType == 34
                                                                                        ? 'StationDetails'
                                                                                        : json.DtoType == 35
                                                                                          ? 'StationRole'
                                                                                          : json.DtoType == 36
                                                                                            ? 'UserRole'
                                                                                            : 'BiathlonPicture',
            EventID: json.EventID ?? null,
            OrganizerID: json.OrganizerID ?? null,
        });
    }

    /**
     * Creates an instance of SignalrDbDataChangedSubscribeParameters from another instance of SignalrDbDataChangedSubscribeParameters.
     * @param other The SignalrDbDataChangedSubscribeParameters you want to clone
     * @returns A cloned SignalrDbDataChangedSubscribeParameters
     */
    public static FromOther(other: SignalrDbDataChangedSubscribeParameters): SignalrDbDataChangedSubscribeParameters {
        return SignalrDbDataChangedSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrDbDataChangedSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrDbDataChangedSubscribeParameters';
}
